import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { ROUTES } from "@/domain/constants/routes";
import { PageLayout } from "@/ui/components/common/PageLayout";

/**
 * 權限拒絕頁面組件
 * 當用戶嘗試訪問沒有權限的頁面時顯示
 */
export function PermissionDeniedPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <PageLayout title={t("errors.permission_denied")}>
      <div className="flex flex-col items-center justify-center py-12">
        <div className="mb-8">
          <div className="flex justify-center mb-6">
            <svg
              className="w-24 h-24 text-red-600 dark:text-red-500"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M12 15v2m0 0v2m0-2h2m-2 0H9m3-3V8m0 0V6m0 2h2M9 10h2"
              />
              <circle cx="12" cy="12" r="10" strokeWidth="2" />
            </svg>
          </div>
          <h1 className="text-5xl font-bold text-gray-800 dark:text-gray-200 mb-2">
            403
          </h1>
          <div className="h-2 w-24 bg-red-600 mx-auto my-4"></div>
          <h2 className="text-2xl font-semibold text-gray-700 dark:text-gray-300 mb-4">
            {t("errors.permission_denied")}
          </h2>
          <p className="text-gray-600 dark:text-gray-400 mb-8">
            {t("errors.permission_denied_message")}
          </p>
        </div>

        <div className="flex flex-col space-y-4 sm:flex-row sm:space-y-0 sm:space-x-4 justify-center">
          <button
            onClick={() => navigate(-1)}
            className="px-6 py-3 bg-gray-200 hover:bg-gray-300 dark:bg-gray-700 dark:hover:bg-gray-600 text-gray-800 dark:text-gray-200 font-medium rounded-md transition-colors duration-200"
          >
            {t("errors.go_back")}
          </button>
          <Link
            to={ROUTES.HOME}
            className="px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-md transition-colors duration-200"
          >
            {t("common.back_to_home")}
          </Link>
          <a
            href="mailto:admin@example.com"
            className="px-6 py-3 bg-red-600 hover:bg-red-700 text-white font-medium rounded-md transition-colors duration-200"
          >
            {t("errors.contact_admin")}
          </a>
        </div>
      </div>
    </PageLayout>
  );
}
